module.exports = __webpack_public_path__ + "img/thumbnail_PereDavidsDeer_f_normal.5fbe1f2a.png";